import { NotificationState } from '@/redux/reducers/notifications';
import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';

export const getNotificationsSelector = () =>
  createSelector(
    (state: DefaultRootState) => state.notification,
    ({ notifications }: NotificationState) => notifications
  );
